export const mappingEquipmentFilterData = (panels) => {
  return panels.map((panel) => ({
    id: panel.id ?? 'all_panels',
    label: panel.name,
    value: panel.devices.map((device) => ({
      id: device.id ?? 'all_devices',
      label: `${device.name} (${device.count})`,
      value: device.id ?? 'all_devices',
    })),
  }))
}
